import {
  assign,
  createMachine,
  ErrorPlatformEvent,
  Interpreter,
  spawn,
  Actor,
} from 'xstate-v4'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { PaymentCard } from '../schema'

interface UserStoredCardsContext {
  cards: Record<string, Actor>
  cardMachine: any
}

interface UserStoredCardsEvent {
  type: 'REMOVE'
  cardId: string
}

export function returnUserStoredCardsMachine() {
  return createMachine<UserStoredCardsContext, UserStoredCardsEvent>(
    {
      context: {
        cards: {},
        cardMachine: {},
      },
      initial: 'initializing',
      states: {
        initializing: {
          invoke: {
            src: 'getCards',
            onDone: {
              target: 'showing',
              actions: assign({
                cards: (ctx, { data }) => {
                  return (data as PaymentCard[]).reduce(
                    (accumulator, card) => {
                      accumulator[card.id] = spawn(
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- XState v4 cardMachine typing
                        ctx.cardMachine.withContext(card),
                      )
                      return accumulator
                    },
                    {} as Record<string, Actor>,
                  )
                },
              }),
            },
            onError: {
              target: 'error',
              actions: 'logError',
            },
          },
        },
        showing: {
          on: {
            REMOVE: {
              actions: assign({
                cards: (ctx, event) => {
                  const amendedCards = { ...ctx.cards }
                  delete amendedCards[event.cardId]
                  return amendedCards
                },
              }),
              internal: true,
            },
          },
        },
        error: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: (_ctx, _event) => {
          const event = _event as ErrorPlatformEvent
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- XState v4 event.data typing
          event.data.name = `userStoredCardsMachine ${event.type} error`
          sentryCapture(event.data, rootContainer)
        },
      },
    },
  )
}
export type UserStoredCardsMachineInterpreter = Interpreter<
  UserStoredCardsContext,
  any,
  UserStoredCardsEvent
>
